export default __webpack_public_path__ + "static/media/zhongli.d00cd390.png";